/** @file readAttachmentFields: an input's optional attachment metadata (group, when with draw, driver). */
import type { Attachment } from '@zilo/pose3d-format/types/puppet';
import { checkShape } from '@zilo/pose3d-format/validate/fields/checkShape';
import { checkString } from '@zilo/pose3d-format/validate/fields/checkString';
import { NAME_PATTERN } from '@zilo/pose3d-format/validate/fields/namePattern';
import { ATTACHMENT_WHEN_SHAPE } from '@zilo/pose3d-format/validate/shapes/attachmentWhenShape';
import type { readInput } from '../validate/readInput';

const name = checkString(NAME_PATTERN);
const when = checkShape(ATTACHMENT_WHEN_SHAPE);

/** `weaponGroup`, `when` and `driver` read with `r` (each `undefined` when absent). */
export function readAttachmentFields(r: ReturnType<typeof readInput>): Pick<Attachment, 'weaponGroup' | 'when' | 'driver'> {
  return {
    weaponGroup: r.opt('weaponGroup', (k) => r.check(k, name) as string),
    when: r.opt('when', (k) => r.check(k, when) as NonNullable<Attachment['when']>),
    driver: r.opt('driver', (k) => r.check(k, name) as string),
  };
}
